import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type AccommodationTypeId = Branded<string, "AccommodationTypeId">;
const accommodationTypeIdPrefix = "accommodation_type__";
const {
    factory: accommodationTypeIdFactory,
    assert: isAccommodationTypeId,
    zodSchema: accommodationTypeIdZodSchema,
} = genericId<AccommodationTypeId>(accommodationTypeIdPrefix, {
    regexMatch: /^(accommodation[-_]type__).*$/,
    // remove above and only accept accommodation_type__ prefix when
    // sandbox has been updated
});

export {
    accommodationTypeIdFactory,
    accommodationTypeIdPrefix,
    accommodationTypeIdZodSchema,
    isAccommodationTypeId,
};
export type { AccommodationTypeId };
